import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
// Captain routes disabled - superseded by AgentBot module.
// import { routes as captainRoutes } from './captain/captain.routes';
// Top-level flow editor (full screen vue-flow). Admin list/CRUD lives in
// settings - see routes/dashboard/settings/agentBots/agentBot.routes.js.
import agentBotsRoutes from './agentBots/agentBots.routes';
import pipelinesRoutes from './pipelines/routes';
import leadsRoutes from './leads/routes';
import funnelRoutes from './reports/funnel/funnel.routes';
import internalChatRoutes from './internalChat';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        // ...captainRoutes - disabled (replaced by agentBots module)
        ...agentBotsRoutes.routes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...pipelinesRoutes.routes,
        ...leadsRoutes.routes,
        ...funnelRoutes.routes,
        ...internalChatRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
